import logo from "./assets/images/logo.png";
import note from "./assets/images/note.svg";
import chevronRight from "./assets/images/chevron-right.svg";
import phoneImg from "./assets/images/emoji.png";
import pdf from "./assets/files/핵심요약__민사고가 3년 전액 장학생 21명을 찾습니다.pdf";

function App() {
  return (
    <div className="App">
      <section className="white-bg first-section">
        <div className="content-wrapper">
          <div className="logo">
            <img src={logo} alt="logo" />
          </div>
          <h1 className="font-bold font-title">민족사관고등학교에서</h1>
          <h1 className="font-bold font-title desktop">
            2022년 전액장학생을 모집합니다
          </h1>
          <h1 className="font-bold font-title mobile">2022년 전액장학생을</h1>
          <h1 className="font-bold font-title mobile">모집합니다</h1>
          <div className="beige-box">
            <p className="font-bold">장학생 지원내역</p>
            <h3 className="font-subtitle font-bold">약 1억원 상당의</h3>
            <h3 className="font-subtitle font-bold">
              재학 기간 3년 교육비 전액
            </h3>
            <div className="boxes">
              <div className="box desktop">
                <div>
                  <p>학교운영</p>
                  <p>지원비</p>
                </div>
              </div>
              <div className="box desktop">
                <p>입학금</p>
              </div>
              <div className="box desktop">
                <p>수업료</p>
              </div>
              <div className="box desktop">
                <p>기숙사비</p>
              </div>
              <div className="box desktop">
                <div>
                  <p>기타 교육</p>
                  <p>경비 일체</p>
                </div>
              </div>
              <div className="row">
                <div className="box mobile">
                  <div>
                    <p>학교운영</p>
                    <p>지원비</p>
                  </div>
                </div>
                <div className="box mobile">
                  <p>입학금</p>
                </div>
              </div>
              <div className="row">
                <div className="box mobile">
                  <p>수업료</p>
                </div>
                <div className="box mobile">
                  <p>기숙사비</p>
                </div>
              </div>
              <div className="row">
                <div className="box mobile">
                  <div>
                    <p>기타 교육</p>
                    <p>경비 일체</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="grey-bg">
        <div className="content-wrapper">
          <h1 className="font-bold font-title font-white">모집 인원: 16명</h1>
          <div className="boxes">
            <div className="box">
              <div className="count-box font-bold">10명</div>
              <div className="scholarship-name">선혜장학생전형</div>
              <div className="scholarship-desc">
                정몽진 KCC 회장의 뜻에 따라, 미래 대한민국 발전에 적극
                헌신하고자 하는 인재를 장학생으로 선발하여 재학 중 3년 동안 교육
                경비 일체를 장학금으로 수여함
              </div>
            </div>
            <div className="box">
              <div className="count-box font-bold">5명</div>
              <div className="scholarship-name">영혜장학생1전형</div>
              <div className="scholarship-desc">
                고 정상영 KCC 명예회장의 뜻에 따라, 미래 대한민국 발전에 적극
                헌신하고자 하는 인재를 장학생으로 선발하여 재학 중 3년 동안 교육
                경비 일체를 장학금으로 수여함
              </div>
            </div>
            <div className="box">
              <div className="count-box font-bold">1명</div>
              <div className="scholarship-name">동문장학생전형</div>
              <div className="scholarship-desc">
                민족사관고등학교 설립이념에 따라 민족을 위한 봉사와 참된
                지도자의 자세를 견지할 마음을 가진 자이며 졸업 후 자랑스러운
                동문으로서 동문회 활동을 위해 노력하고자 하는 인재를 장학생으로
                선발하여 재학 중 3년 동안 교육 경비 일체를 장학금으로 수여함
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="white-bg third-section">
        <div className="content-wrapper">
          <h1 className="font-bold font-title font-titleblack desktop">
            전액장학생 특별전형 지원 자격(공통)
          </h1>
          <h1 className="font-bold font-title font-titleblack mobile">
            전액장학생 특별전형
          </h1>
          <h1 className="font-bold font-title font-titleblack mobile">
            지원 자격(공통)
          </h1>
          <div className="desc-wrapper">
            <div className="prerequisite-desc desktop">
              1. 가구소득이 기준중위소득 150% 이하인 가구에 속한 자
            </div>
            <div className="prerequisite-desc desktop">
              2. 가정형편이 어려운 자로 학교장 또는 읍·면·동장의 추천을 받은
              자(소득조건 없음)
            </div>
            <div className="prerequisite-desc mobile">
              <p>1. 가구소득이 기준중위소득 150% 이하인</p>
              <p>가구에 속한 자</p>
            </div>
            <div className="prerequisite-desc mobile">
              <p>2. 가정형편이 어려운 자로 학교장 또는</p>
              <p>읍·면·동장의 추천을 받은 자(소득조건 없음)</p>
            </div>
          </div>
          <div className="special-notice desktop">
            전액장학생 특별전형 지원자는 세 가지 전형에 중복지원이 가능합니다.
          </div>
          <div className="special-notice mobile">
            <p>전액장학생 특별전형 지원자는 세 가지 전형에</p>
            <p>중복지원이 가능합니다.</p>
          </div>
          <div className="btns">
            <a className="btn gradient-bg" href={pdf} download>
              장학생선발 설명서 다운로드
            </a>
            <a
              className="btn"
              href="https://www.minjok.hs.kr/sub04_01_05.php"
              target="_blank"
              rel="noreferrer"
            >
              공식 홈페이지 바로가기
            </a>
          </div>
        </div>
      </section>
      <section className="light-grey-bg">
        <div className="content-wrapper">
          <h1 className="font-bold font-title font-titleblack desktop">
            민사고 입시 더 알아보기
          </h1>
          <h1 className="font-bold font-title font-titleblack mobile">
            민사고 입시
          </h1>
          <h1 className="font-bold font-title font-titleblack mobile">
            더 알아보기
          </h1>
          <div className="learn-more-desc">
            <p>민족사관고등학교 동문회에서 준비한</p>
            <p>민사고 지원 가이드를 확인해보세요.</p>
          </div>
          <div className="btns">
            <a
              className="btn"
              href="https://www.youtube.com/watch?v=sPjWXuo171E"
              target="_blank"
              rel="noreferrer"
            >
              <div className="content">
                <div className="note-icon-wrapper">
                  <img src={note} alt="note" />
                </div>
                <div className="desc">전액장학생 특별전형 영상 가이드</div>
              </div>
              <div className="show-more">
                <div className="show-more-desc">보러가기</div>
                <div className="chevron-right">
                  <img src={chevronRight} alt="right-arrow" />
                </div>
              </div>
            </a>
            <a
              className="btn"
              href="https://blog.naver.com/shamujr/222558420491"
              target="_blank"
              rel="noreferrer"
            >
              <div className="content">
                <div className="note-icon-wrapper">
                  <img src={note} alt="note" />
                </div>
                <div className="desc">전체 전형 가이드</div>
              </div>
              <div className="show-more">
                <div className="show-more-desc">보러가기</div>
                <div className="chevron-right">
                  <img src={chevronRight} alt="right-arrow" />
                </div>
              </div>
            </a>
          </div>
        </div>
      </section>
      <section className="white-bg last-section">
        <div className="content-wrapper">
          <div className="table">
            <h2 className="font-bold">온라인 학교 설명회 안내</h2>
            <div className="table-content">
              <div className="dates desktop">
                10월 27일(수), 10월 30일(토), 11월 3일(수), 11월 10일(수)
              </div>
              <div className="dates mobile">
                <p>10월 27일(수), 10월 30일(토),</p>
                <p>11월 3일(수), 11월 10일(수)</p>
              </div>
              <div className="desc desktop">
                ZOOM을 통해 온라인 학교설명회가 진행되며, 아래 링크를 통해
                신청하실 수 있습니다.
              </div>
              <div className="desc mobile">
                <p>ZOOM을 통해 온라인 학교설명회가 진행되며,</p>
                <p>아래 링크를 통해 신청하실 수 있습니다.</p>
              </div>
              <a
                className="btn"
                href="https://www.minjok.hs.kr/sub04_02_02.php"
                target="_blank"
                rel="noreferrer"
              >
                설명회 참석 예약하기
              </a>
            </div>
          </div>
          <div className="contact">
            <div className="left desktop">
              <div className="img-wrapper">
                <img src={phoneImg} alt="phone" />
              </div>
              <div className="text-wrapper">
                <div className="title">문의 및 상담: 민사고 입학관리실</div>
                <div className="details">
                  070-4742-0100 | iphak@minjok.hs.kr
                </div>
              </div>
            </div>
            <div className="right desktop">
              <a
                className="btn"
                href="https://www.minjok.hs.kr/"
                target="_blank"
                rel="noreferrer"
              >
                홈페이지 바로가기
              </a>
            </div>
            <div className="mobile">
              <div className="img-wrapper">
                <img src={phoneImg} alt="phone" />
              </div>
              <div className="title">
                <p>문의 및 상담:</p>
                <p>민사고 입학관리실</p>
              </div>
              <div className="details">070-4742-0100 | iphak@minjok.hs.kr</div>
              <div className="btn">홈페이지 바로가기</div>
            </div>
          </div>
        </div>
      </section>
      <footer>
        <div className="copyright desktop">
          © Copyright 1996-2020 KMLA, All rights reserved
        </div>
        <div className="addr-and-tel desktop">
          25268, 강원도 횡성군 안흥면 봉화로 800 민족사관고등학교 | TEL:
          033-343-1115 | FAX: 033-342-8660
        </div>
        <div className="copyright mobile">
          <p>© Copyright 1996-2020 KMLA,</p>
          <p>All rights reserved</p>
        </div>
        <div className="addr-and-tel mobile">
          <p>25268, 강원도 횡성군 안흥면 봉화로 800 민족사관고등학교</p>
          <p>TEL: 033-343-1115 | FAX: 033-342-8660</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
